<script lang="ts">
    import ExclamationCircleIcon from './ExclamationCircleIcon.svelte';

    import type { Language } from '$lib/types/Language';

    export let language: Language = 'en';

    const errorText =
        language === 'en'
            ? 'Set up Stripe to receive payments'
            : 'Richte Stripe ein, um Zahlungen zu erhalten';
</script>

<div
    class="fun-flex fun-gap-2 fun-rounded-full fun-bg-red-600 fun-px-5 fun-py-2 fun-font-semibold fun-text-white"
>
    <ExclamationCircleIcon className="fun-size-6" />

    {errorText}
</div>
